import type { State } from './types';

/**
 * Environment selectors for accessing environment configuration.
 * These selectors are designed to avoid cyclic dependencies.
 */

export const getJsmAIConfigEnabled = (state: State): boolean =>
    !!state.persisted.env.featuredValues?.jsmAiConfigEnabled;

export const getHelpCenterType = (state: State): string => state.persisted.env.helpCenterType;

export const getHoistedProjectKey = (state: State): string | undefined => state.persisted.env.hoistedProjectKey;

export const getJiraDisplayUrl = (state: State): string => state.persisted.env.jiraDisplayUrl;
